import {useCallback} from 'react';
import type {Locale} from 'localization/types';
import {useAppDispatch} from 'store/hooks';
import type {ThesaurusId} from '../types';
import {useLazyGetThesaurusQuery} from '../thesaurusApi';
import {loadThesaurus} from '../thesaurusSlice';

export const useLoadThesaurus = () => {
  const dispatch = useAppDispatch();
  const [trigger] = useLazyGetThesaurusQuery();

  return useCallback(
    (id: ThesaurusId, language: Locale) => {
      dispatch(
        loadThesaurus({
          id,
          data: {
            status: 'Loading',
          },
        }),
      );

      trigger({id, language})
        .unwrap()
        .then(data => {
          dispatch(
            loadThesaurus({
              id,
              data: {
                status: 'Loaded',
                data,
              },
            }),
          );
        })
        .catch(error => {
          dispatch(
            loadThesaurus({
              id,
              data: {
                status: 'Failed',
                error: error,
              },
            }),
          );
        });
    },
    [dispatch, trigger],
  );
};
